import { API_ENDPOINT } from 'src/config/env.config';
import { BaseAPIResponse } from 'types';
import { baseApi } from './axios';

const baseUrl = `${API_ENDPOINT}/lms-techstack`;

export interface LMSTechStack {
	_id?: string;
	name: string; // Exact enum value (e.g., 'MasaiStudent') - stored in DB
	label?: string; // Display name for UI (e.g., 'Masai Student') - only for display
	description?: string;
	category?: string;
	isActive?: boolean;
	showInMenu?: boolean;
	createdBy?: string;
	updatedBy?: string;
	createdAt?: Date;
	updatedAt?: Date;
}

export interface GetLMSTechStacksAPIResponse extends BaseAPIResponse {
	lmsTechStacks?: LMSTechStack[];
}

export interface GetLMSTechStackByIdAPIResponse extends BaseAPIResponse {
	lmsTechStack?: LMSTechStack;
}

export const getLMSTechStacks = async (isActive?: boolean, category?: string, showInMenu?: boolean, usePublicRoute?: boolean): Promise<GetLMSTechStacksAPIResponse> => {
	const params = new URLSearchParams();
	if (isActive !== undefined) params.append('isActive', String(isActive));
	if (category) params.append('category', category);
	if (showInMenu !== undefined) params.append('showInMenu', String(showInMenu));

	// Use public route for support ticket categories/subcategories (for jobseekers)
	const route = usePublicRoute ? '/public/all' : '/all';
	const url = params.toString() ? `${baseUrl}${route}?${params.toString()}` : `${baseUrl}${route}`;
	const response = await baseApi.get(url);
	return response.data;
};

export const getLMSTechStackById = async (id: string): Promise<GetLMSTechStackByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/${id}`);
	return response.data;
};
